module.exports = __webpack_public_path__ + "media/images/emoticons/happy01-14d74e4888df005043f61c67445baf62.gif";